import React from 'react';
import { Card, Flex, Input, Space, Table } from 'antd';

const { Search } = Input;

const UserListDesktop = ({ viewModel }) => {
  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Search
            placeholder='Tên hoặc số điện thoại'
            onChange={(e) => viewModel.setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
            value={viewModel.filter.info}
          />
          <Flex justify='flex-end' style={{ width: '100%' }} />
        </Space>
      </Card>

      <Card>
        <Table columns={viewModel.columns} dataSource={viewModel.data} rowKey='id' />
      </Card>
    </Space>
  );
};

export default React.memo(UserListDesktop);
